import type { InvariantJiraRoute } from '@atlassian/jira-route-types/src/InvariantJiraRoute.tsx';

export const legacyProjectReleasesBambooRoute: InvariantJiraRoute = {
	name: 'legacy-project-releases-bamboo',
	path: '/secure/ConfigureBambooRelease([!%]?[\\w]*).jspa',
};
